import { jsx } from 'react/jsx-runtime';
import { Box } from '../Box/Box.mjs';

const ContentLayout = ({ children }) => {
    return (jsx(Box, { paddingLeft: 10, paddingRight: 10, children: children }));
};

export { ContentLayout };
